module.exports = __webpack_public_path__ + "img/new-int-asses.33825604.svg";